import { CheckRequestWithdrawList } from 'features';
import React from 'react';

const CheckRequestWithdrawPage = () => {
  return <CheckRequestWithdrawList />;
};

export default CheckRequestWithdrawPage;
